import { render, staticRenderFns } from "./mGameResultCatNav.vue?vue&type=template&id=12a9dd34&scoped=true"
import script from "./mGameResultCatNav.vue?vue&type=script&lang=js"
export * from "./mGameResultCatNav.vue?vue&type=script&lang=js"
import style0 from "./mGameResultCatNav.vue?vue&type=style&index=0&id=12a9dd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9dd34",
  null
  
)

export default component.exports